import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/documents/uploaded')({ component: Outlet })
